/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React, { PropsWithChildren } from 'react';
import { ListItemText } from '@mui/material';

const DecoratedText = ({ children, underline }: PropsWithChildren<{ underline?: boolean }>) => {
  return (
    <ListItemText
      primaryTypographyProps={{
        sx: {
          textDecorationLine: underline ? 'underline' : 'none',
          textDecorationThickness: '1px',
          textUnderlineOffset: '2px',
        },
      }}
    >
      {children}
    </ListItemText>
  );
};

export const FulfilmentFAQsText = () => {
  return <DecoratedText>Fulfilment FAQs</DecoratedText>;
};

export const TermsAndConditionsText = ({ underline = true }: { underline?: boolean }) => {
  return <DecoratedText underline={underline}>Terms & Conditions</DecoratedText>;
};
